export const COACH_NUTRITION_RESOURCE_FOODS = "foods";
export const COACH_NUTRITION_RESOURCE_RECIPES = "recipes";
export const COACH_NUTRITION_RESOURCE_EQUIVALENTS = "equivalents";
export const COACH_NUTRITION_RESOURCE_PLANS = "plans";

export const COACH_NUTRITION_RESOURCE_ORDER = Object.freeze([
  COACH_NUTRITION_RESOURCE_FOODS,
  COACH_NUTRITION_RESOURCE_EQUIVALENTS,
  COACH_NUTRITION_RESOURCE_RECIPES,
  COACH_NUTRITION_RESOURCE_PLANS,
]);

export const COACH_NUTRITION_BOOTSTRAP_RESOURCES = Object.freeze({
  coachScreen: Object.freeze([...COACH_NUTRITION_RESOURCE_ORDER]),
  addFoodModal: Object.freeze([COACH_NUTRITION_RESOURCE_FOODS]),
  equivalentEditor: Object.freeze([COACH_NUTRITION_RESOURCE_FOODS]),
  recipeEditor: Object.freeze([
    COACH_NUTRITION_RESOURCE_FOODS,
    COACH_NUTRITION_RESOURCE_EQUIVALENTS,
  ]),
  nutritionPlanEditor: Object.freeze([
    COACH_NUTRITION_RESOURCE_FOODS,
    COACH_NUTRITION_RESOURCE_EQUIVALENTS,
    COACH_NUTRITION_RESOURCE_RECIPES,
  ]),
  clientImportModal: Object.freeze([COACH_NUTRITION_RESOURCE_PLANS]),
});

export function normalizeCoachNutritionResourceKeys(resourceKeys = []) {
  const requestedKeys = new Set(
    (Array.isArray(resourceKeys) ? resourceKeys : [])
      .map((resourceKey) => String(resourceKey ?? "").trim().toLowerCase())
      .filter(Boolean),
  );

  return COACH_NUTRITION_RESOURCE_ORDER.filter((resourceKey) =>
    requestedKeys.has(resourceKey),
  );
}
